.root[data-variant='cells'] {
  .item {
    border-radius: 12px;
    background-color: var(--mantine-color-white);
    padding: 0;
    border: 1px solid var(--mantine-color-gray-1);
    margin-bottom: var(--mantine-spacing-xxs);

    &[data-active='true'] {
      background-color: var(--mantine-color-gray-0);
    }
  }

  .content {
    background-color: var(--mantine-color-white);
  }

  .chevron {
    width: auto;
    margin-left: var(--mantine-spacing-sm);
  }
}

.root[data-variant='document-entity'] {
  padding: 0;
  margin: 0;

  .item {
    background-color: var(--mantine-color-gray-1);
    border-bottom: none;
    border-radius: 16px;

    .label {
      padding: 0;
    }

    .control {
      padding: var(--mantine-spacing-md);
    }

    .content {
      padding: 0;
    }

    .panel {
      background-color: var(--mantine-color-gray-1);
      padding: var(--mantine-spacing-md);
      padding-top: 0;
      border-radius: 16px;
    }
  }
}

.root[data-variant='vertical-tabs'] {
  .chevron {
    background-color: var(--mantine-color-gray-1);
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .control {
    padding: 0px;
    padding-bottom: var(--mantine-spacing-xs);
  }

  .content {
    padding-right: 0;
    border-left: solid 1px var(--mantine-color-gray-1);
    padding-left: var(--mantine-spacing-xs);
  }

  .item {
    .label {
      padding: 0 var(--mantine-spacing-xxs);
      color: var(--mantine-color-gray-7);
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
    }
  }
}

.root[data-variant='form'] {
  .chevron {
    background-color: white;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    margin-right: var(--mantine-spacing-xs);
  }

  .item {
    background-color: var(--mantine-color-gray-1);
    border-radius: 16px;
    padding: var(--mantine-spacing-md);
  }

  .item {
    margin-bottom: var(--mantine-spacing-xs);

    &:last-child {
      margin-bottom: 0;
    }

    .label {
      padding: 0;
      color: var(--mantine-color-gray-10);
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
    }
  }
}
